import { render, staticRenderFns } from "./ed-whiteboard-menu.component.vue?vue&type=template&id=f0746280&scoped=true&"
import script from "./ed-whiteboard-menu.component.ts?vue&type=script&lang=ts&"
export * from "./ed-whiteboard-menu.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-whiteboard-menu.component.scss?vue&type=style&index=0&id=f0746280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0746280",
  null
  
)

export default component.exports